import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  SearchBar,
  LoadMore,
  Toast,
  Panel,
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from '../lib/formatter.ts';
import { withStyles } from '@material-ui/core/styles';
import Http from 'services/http2';
import User from 'services/user2';
import EnumService from 'services/enum2';
import TopNav from 'components/topNav.js';
import CompanyService from 'services/company2';
import ClearIcon from '@material-ui/icons/Clear';
import * as MobileActions from 'actions/index.ts';
import '../orderReport.css';
import Util from 'lib/util.js';
import ExtendFields from 'components/extendFields';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Download from 'components/download.js';
import dayjs from 'dayjs';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import TodayIcon from '@material-ui/icons/Today';
/* dev
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Forder%2Freport%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fsale%2Fcustomer%2Freport%2Flist&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/

const styles = theme => ({
  inputAdornment: {
    width: 18,
  },
});

const Config = {
  customerOrderReport: {
    title: '订单执行进度',
    apiPath: '/customerPurchase/report/boardList',
    totalApiPath: '/customerPurchase/report/queryBoardTotal',
    enumMainKey: 'B02_NCPo_Status',
    companyNameKey: 'innerName',
    detailLink: '/mp/sale/customer/order/detail',
    searchBarPlaceholder: '客户名称/编码、订单编号、商品名称/编码/规格',
    tabs: ['未完成订单', '全部订单'],
    tabConfig: [
      [0, 1], //未完成订单
      undefined, //全部
    ],
    orderType: [1, undefined],
    companyCodeKey: 'customerCode',
  },
  purchaseOrderReport: {
    title: '订单执行进度',
    apiPath: '/purchase/report/boardList',
    totalApiPath: '/purchase/report/queryBoardTotal',
    enumMainKey: 'B02_NPo_Status',
    companyNameKey: 'innerName',
    detailLink: '/mp/purchase/order/detail',
    searchBarPlaceholder: '供应商名称/编码、订单编号、商品名称/编码/规格',
    tabs: ['未完成订单', '全部订单'],
    tabConfig: [
      [0, 1], //未完成订单
      undefined, //全部
    ],
    orderType: [1, undefined],
    companyCodeKey: 'companyCode',
  },
};

class OrderReportList extends Component {
  constructor(props) {
    super(props);
    this.reset = false;
    this.companyCode = '';
    this.pageNum = 1;
    this.searchKey = '';
    this.total = 0;
    this.handleClear = this.handleClear.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.extendSeach = this.extendSeach.bind(this);
    this.handleCustomerChange = this.handleCustomerChange.bind(this);
    this.rangeChange = this.rangeChange.bind(this);
    this.config = Config[props.type];
    this.resolveLoading = () => { }; //引用InfiniteLoader中resolveLoading方法，用于重置列表加载状态
    this.count = [];
    this.extendSearchParams = []; //采购说明
    this.currentTab = 0; //当前页签
    this.state = {
      inited: false,
      error: null,
      dataError: null,
      list: [],
      showLoading: true,
      isShowSearch: false,
      receiveStatus: this.config.tabConfig[this.currentTab],
      orderType: this.config.orderType[this.currentTab],
      totalData: {},
      unitNum: {},
      fileList: [],
      dateRange: [],
    };
    this.extendComapnyCode = ''; //采购说明companyCode
    this.isPurchase = props.type === 'purchaseOrderReport';
    this.customerList = [];
    this.customerXkUniqueCode = '';
    this.searchQueries = {
      poLineRemark: '',
    };
  }

  init() {
    User.init().then(response => {
      if (response.success) {
        this.setState({ inited: true });
        this.companyCode = User.getCompanyCode();
        if (this.isPurchase) {
          this.extendComapnyCode = this.companyCode;
        } else {
          this.getCustomerList();
        }
        this.beforeInit().then(() => {
          this.getList();
        });
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() { }

  //初始化默认日期范围
  async beforeInit() {
    //init date range
    let now = Date.now();
    let mEnd = dayjs(now).endOf('day');
    let end = mEnd.format('YYYY-MM-DD');
    let begin = dayjs(end).subtract(1, 'months').format('YYYY-MM-DD');

    await this.setState({ dateRange: [begin, end] });
  }

  //日期范围改变
  rangeChange(i, e) {
    let value = e.target.value;
    if (i === 0) {
      this.setState({ dateRange: [value, ''] });
      return;
    }
    let ts = Date.parse(value);
    let arr = this.state.dateRange.map(item => Date.parse(item));
    arr[i] = ts;
    let dateRange = [
      dayjs(arr[0]).format('YYYY-MM-DD'),
      dayjs(arr[1]).format('YYYY-MM-DD'),
    ];
    let delta = arr[1] - arr[0];
    if (delta > 0) {
      this.setState({ dateRange: dateRange }, () => {
        this.search();
      });
    } else {
      this.setState({ dateRange: [value, value] });
    }
  }

  //搜索前参数注入
  beforeSearch() {
    let arr = this.state.dateRange;
    this.searchQueries.erpPurchaseDateStart = Date.parse(arr[0]);
    this.searchQueries.erpPurchaseDateEnd = Date.parse(arr[1]);
  }

  getList(cb = () => { }) {
    this.beforeSearch();
    let enumMainKey = this.config.enumMainKey;
    let postbody = {
      apiPath: this.config.apiPath,
      ascOrDesc: 'desc',
      companyCode: this.companyCode,
      customerCode: this.isPurchase ? '' : this.extendComapnyCode,
      customerXkUniqueCode: this.isPurchase ? '' : this.customerXkUniqueCode,
      orderProperty: 'pol.createTime',
      receiveStatus: this.state.receiveStatus,
      status: this.state.receiveStatus,
      pageNum: this.pageNum,
      pageSize: 10,
      searchKey: this.searchKey,
      ...this.searchQueries,
      extendSearchParams: this.extendSearchParams,
      orderType: this.state.orderType,
    };
    let arrPromise = [
      Http.post('/api/cloudCenter', postbody),
      EnumService.getList(enumMainKey),
    ];
    this.setState({ dataError: null });
    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      this.reset = false;
      this.setState({ showLoading: false });
      if (response.success) {
        let list = response.data.list;
        list.forEach((item, index) => {
          this.calculateReportQtys(item);
          //采购说明
          Util.genExtendFields(item);
          //小数位获取
          let companyCode =
            this.props.type === 'customerOrder'
              ? item.customerCode
              : this.companyCode;
          CompanyService.getDecimalPlaceByCodes(companyCode).then(rs => {
            let obj = {};
            for (let code in rs) {
              obj[code] = rs[code];
            }
            this.setState({ unitNum: obj });
          });
          if (item.erpAttach) {
            item.attachCount =
              item.attachCount === undefined ? 0 : item.attachCount;
            item.attachCount += item.erpAttach.split(';').length;
          }
        });
        this.setState({ list: this.state.list.concat(list) }, () => cb());
        this.pageNum += 1;
        this.total = response.data.total;
        this.getOutPresetRange(postbody);
      } else {
        this.setState({
          dataError: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  getOutPresetRange(param) {
    let postbody = {
      ...param,
      apiPath: this.config.totalApiPath,
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let totalData = {
          isOutPresetRange: response.data.outPresetRange,
          totalAnswerQty: response.data.totalAnswerQty,
          totalPoWaitDeliveryQty: response.data.totalPoWaitDeliveryQty,
          totalOnOrderQty: response.data.totalOnOrderQty,
        };
        this.setState({ totalData: totalData });
      }
    });
  }

  getCustomerList() {
    let postbody = {
      companyCode: this.companyCode,
      inviteStatusList: [2],
      customerStatus: 1,
      apiPath: '/archives/compCustomer/getSimpleListByCompCode',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data || [];
        this.customerList = data.map(custom => {
          return {
            id: custom.xkUniqueCode,
            text: custom.innerCustomerCode
              ? custom.innerCustomerCode + '--' + custom.innerCustomerName
              : custom.innerCustomerName,
            customerCode: custom.customerCode,
          };
        });
      }
    });
  }

  //选择客户
  handleCustomerChange(event) {
    let companyCode = event.target.value;
    this.customerList.forEach(item => {
      if (item.customerCode === companyCode) {
        this.customerXkUniqueCode = item.id;
      }
    });
    this.extendComapnyCode = companyCode;
    this.setState({
      extendComapnyCode: this.extendComapnyCode,
      customerXkUniqueCode: this.customerXkUniqueCode,
    });
  }

  handleCompanyChange(companyCode) {
    this.companyCode = companyCode;
    this.setState({ showLoading: true });
    this.handleReset();
  }

  handleChange(text, e) {
    e.preventDefault();
    this.searchKey = text;
    this.handleReset();
  }

  handleClear() {
    this.searchKey = '';
    this.handleReset();
  }

  handleTab(index) {
    this.currentTab = index;
    this.setState(
      {
        receiveStatus: this.config.tabConfig[index],
        status: this.config.tabConfig[index],
        orderType: this.config.orderType[index],
      },
      () => {
        this.handleReset();
      }
    );
  }

  handleReset() {
    this.reset = true;
    this.setState({
      list: [],
    });
    this.pageNum = 1;
    this.setState({ showLoading: true });
    this.getList();
    this.resolveLoading();
  }

  extendSeach(data) {
    this.extendSearchParams = [data];
    this.setState({ showLoading: true });
    this.handleReset();
  }

  toggleSearch() {
    let isShowsearch = !this.state.isShowSearch;
    this.setState({ isShowSearch: isShowsearch });
  }

  search(text) {
    this.searchKey = text;
    this.setState({ showLoading: true });
    this.getList();
  }

  /**
   * 根据已出货量、报工数量计算报工库存、未完成量（如修改公式，pc页面的逻辑需同步修改）
   * deliveryQty(平台出货量) = 订单出货量 + 系统出货量 + 退货出货量
   * returnQty(退货量) = totalReturnQty + totalExchangeQty
   * @param item:     报工看板列表项
   */
  calculateReportQtys(item) {
    //退货量
    item.returnQty = item.totalReturnQty + item.totalExchangeQty;

    //平台出货量
    // item.deliveryQty =
    //   item.totalCfmDeliveryQty +
    //   item.totalCfmReturnDeliveryQty +
    //   Math.max(Number(item.totalSysDeliveryQty), Number(item.totalCfmSysSupDeliveryQty));
    item.deliveryQty =
      item.totalCfmDeliveryQty +
      item.totalCfmReturnDeliveryQty +
      Number(item.totalCfmSysSupDeliveryQty); //2019/1/8修改

    //总交量
    // item.totalVolume = item.purchaseQty + item.returnQty + item.totalReturnDeliveryQty;
    item.totalVolume = item.purchaseQty + item.returnQty;

    //平台出货量, 报工数量中的较大值
    item.maximum =
      item.deliveryQty - item.totalReportFinishQty > 0
        ? item.deliveryQty
        : item.totalReportFinishQty;

    //未完成量
    // item.unTotalReportFinishQty = item.totalVolume - item.maximum;
    // item.unTotalReportFinishQty = item.unTotalReportFinishQty < 0 ? 0 : item.unTotalReportFinishQty;
    item.unTotalReportFinishRate =
      (item.unFinishStoreQty / item.totalVolume) * 100;
    item.unTotalReportFinishRate =
      item.unTotalReportFinishRate > 100 ? 100 : item.unTotalReportFinishRate;

    //已出货量比例
    item.deliveryRate = (item.deliveryQty / item.totalVolume) * 100;
    item.deliveryRate = item.deliveryRate > 100 ? 100 : item.deliveryRate;

    //完工库存
    item.finishStockQty =
      item.totalReportFinishQty === 0 ? 0 : item.maximum - item.deliveryQty;
    item.finishStockQty = item.finishStockQty < 0 ? 0 : item.finishStockQty;
    item.finishStockRate = (item.finishStockQty / item.totalVolume) * 100;
    item.finishStockRate =
      item.finishStockRate > 100 ? 100 : item.finishStockRate;
  }

  showFileList(businessType, obj) {
    const { actions } = this.props;
    let businessKey =
      businessType === 9 ? obj.poXkNo + '_' + obj.lineNo : obj.poXkNo,
      xkNo = obj.poXkNo,
      lineNo = obj.lineNo,
      cCode = obj[this.config.companyCodeKey];
    this.setState({ showLoading: true });
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      this.setState({ showLoading: false });
      let arr = [];
      if (Array.isArray(res)) {
        arr = res.map(item => {
          return { ...item };
        });
      }
      if (obj.erpAttach) {
        let erpAttachArr = obj.erpAttach.split(';'),
          arr1 = [];
        erpAttachArr.forEach(attach => {
          arr1.push({
            fileUrl: attach,
            fileName: attach,
            sourceType: 'ERP',
          });
        });
        arr = arr.concat(arr1);
      }
      this.setState({ fileList: arr });
    });
    actions.openDownloadModal();
  }

  render() {
    const { classes } = this.props;
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    const unitNum = this.state.unitNum;
    return (
      <Page
        transition={false}
        ptr={false}
        onLoadMore={(resolveLoading, finish) => {
          this.resolveLoading = resolveLoading;
          if (this.state.list.length >= this.total) {
            finish();
          } else {
            this.getList(resolveLoading);
          }
        }}
        className="v2"
      >
        <TopNav
          inited={this.state.inited}
          onSubmit={this.handleChange}
          onCancel={this.handleClear}
          onClear={this.handleClear}
          defaultValue={this.searchKey}
          placeholder={this.config.searchBarPlaceholder}
        />
        <Panel>
          {this.state.isShowSearch && (
            <SearchBar
              onSubmit={this.handleChange}
              onCancel={this.handleClear}
              onClear={this.handleClear}
              defaultValue={this.searchKey}
              placeholder={this.config.searchBarPlaceholder}
              lang={{
                cancel: '取消',
              }}
            />
          )}

          {this.state.dataError !== null ? (
            <Msg {...this.state.dataError} />
          ) : (
            <span>
              <table className="total">
                <thead>
                  <tr>
                    <th>采购总量</th>
                    <th>在途合计</th>
                    <th>待交合计</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{this.state.totalData.totalAnswerQty}</td>
                    <td>{this.state.totalData.totalOnOrderQty}</td>
                    <td>{this.state.totalData.totalPoWaitDeliveryQty}</td>
                  </tr>
                </tbody>
              </table>
              <div>
                {this.state.dateRange.length === 2 && (
                  <div style={{ padding: '0px 10px', marginTop: 10 }}>
                    <TextField
                      label="采购开始日期"
                      variant="outlined"
                      margin="dense"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <TodayIcon />
                          </InputAdornment>
                        ),
                      }}
                      type="date"
                      value={this.state.dateRange[0]}
                      onChange={e => this.rangeChange(0, e)}
                    />
                    <TextField
                      style={{ marginLeft: 5 }}
                      label="采购结束日期"
                      variant="outlined"
                      margin="dense"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            position="start"
                            className={classes.inputAdornment}
                          >
                            <TodayIcon />
                          </InputAdornment>
                        ),
                      }}
                      type="date"
                      value={this.state.dateRange[1]}
                      onChange={e => this.rangeChange(1, e)}
                    />
                  </div>
                )}
              </div>
              {!this.isPurchase && (
                <div style={{ textAlign: 'center' }}>
                  <FormControl
                    style={{ marginRight: '10px', marginTop: '3px' }}
                  >
                    <InputLabel htmlFor="extend-field">请选择客户</InputLabel>
                    <Select
                      style={{ width: '300px' }}
                      value={this.extendComapnyCode}
                      onChange={this.handleCustomerChange}
                      input={<Input id="extend-field" />}
                    >
                      {this.customerList.map((item, index) => (
                        <MenuItem key={index} value={item.customerCode}>
                          <ListItemText primary={item.text} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )}
              <div>
                <ExtendFields
                  style={{
                    width: '70%',
                  }}
                  orgCompanyCode={this.extendComapnyCode}
                  isPurchase={this.isPurchase}
                  onComplete={data => {
                    this.extendSeach(data);
                  }}
                ></ExtendFields>
                <TextField
                  style={{
                    verticalAlign: 'bottom',
                    width: '90%',
                    marginLeft: '10px',
                    marginRight: '10px',
                    marginTop: '0'
                  }}
                  label="采购单号"
                  onChange={event => {
                    this.searchQueries.poErpNo = event.target.value;
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        onClick={() => {
                          this.handleReset();
                        }}
                      >
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  variant="standard"
                />
                <TextField
                  style={{
                    verticalAlign: 'bottom',
                    width: '90%',
                    marginLeft: '10px',
                    marginRight: '10px',
                    marginTop: '0'
                  }}
                  label="产品编码/名称/规格"
                  onChange={event => {
                    this.searchQueries.productKey = event.target.value;
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        onClick={() => {
                          this.handleReset();
                        }}
                      >
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  variant="standard"
                />
                <TextField
                  style={{
                    verticalAlign: 'bottom',
                    width: '90%',
                    marginLeft: '10px',
                    marginRight: '10px',
                    marginTop: '0'
                  }}
                  label="备注"
                  onChange={event => {
                    this.searchQueries.poLineRemark = event.target.value;
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        onClick={() => {
                          this.handleReset();
                        }}
                      >
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  variant="standard"
                />
              </div>
              <div className="m-tab-container">
                <ul className="m-flex-box">
                  {this.config.tabs.map((item, index) => (
                    <li
                      key={index}
                      onClick={this.handleTab.bind(this, index)}
                      className={
                        this.currentTab === index
                          ? 'm-flex-item curr'
                          : 'm-flex-item'
                      }
                    >
                      <span className="name">{item}</span>
                    </li>
                  ))}
                </ul>

                {this.searchKey && (
                  <div className="searchKeyBox">
                    查询信息：
                    <div onClick={this.handleClear}>
                      <span className="singleOmission">{this.searchKey}</span>
                      <ClearIcon
                        className="verticalMiddle"
                        color="primary"
                        fontSize="inherit"
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="list-total">{this.total}</div>
              <div className="m-details-item">
                <div className="details-item-content">
                  {this.state.list.map((item, index) => (
                    <div key={item.id} className="content-line line-list-item">
                      <Link
                        to={`${this.config.detailLink}/${this.companyCode}/${item.poXkNo}`}
                      >
                        <div className="line-list-item-title">
                          <span>{item.poErpNo}</span>
                        </div>
                        <ul className="field-list">
                          {this.isPurchase && (
                            <li>
                              <label>供应商</label>
                              <div>
                                {item.innerName}({item.innerCode})
                              </div>
                            </li>
                          )}
                          {!this.isPurchase && (
                            <li>
                              <label>客户</label>
                              <div>
                                {item.innerName}({item.innerCode})
                              </div>
                            </li>
                          )}
                          <li>
                            <label>采购日期</label>
                            <div>
                              {formatDate(item.erpPurchaseDate, 'YYYY-MM-DD')}
                            </div>
                          </li>
                          <li>
                            <label>产品编码</label>
                            <div>{item.productCode}</div>
                          </li>
                          <li>
                            <label>产品名称</label>
                            <div>{item.productName}</div>
                          </li>
                          <li>
                            <label>产品规格</label>
                            <div>{item.productScale}</div>
                          </li>
                          <li>
                            <label>采购说明</label>
                            <div>{item.printExtendFields}</div>
                          </li>
                          <li>
                            <label>备注</label>
                            <div>{item.remark}</div>
                          </li>
                        </ul>
                      </Link>
                      <div className="order-detail-more">
                        <ul className="field-list">
                          <li>
                            <label>附件</label>
                            <div>
                              {item.attachCount > 0 &&
                                (!self.isPurchase ||
                                  User.checkAuth('10010112') ||
                                  User.checkAuth('10010107')) && (
                                  <span
                                    className="attachment"
                                    onClick={() => this.showFileList(9, item)}
                                  >
                                    {item.attachCount}个附件
                                    <i className="icon-attachment"></i>
                                  </span>
                                )}
                            </div>
                          </li>
                          <li>
                            <label>订单待交数量</label>
                            <div>
                              {formatNumber(
                                item.poWaitDeliveryQty,
                                unitNum.Quantity_Decimal_Place
                              )}
                            </div>
                          </li>
                          <li>
                            <label>补单待出货量</label>
                            <div>
                              {formatNumber(
                                item.sysWaitDeliveryQty,
                                unitNum.Quantity_Decimal_Place
                              )}
                            </div>
                          </li>
                          <li>
                            <label>退货待出数量</label>
                            <div>{formatNumber(
                              item.returnWaitDeliveryQty,
                              unitNum.Quantity_Decimal_Place
                            )}</div>
                          </li>
                          <li>
                            <label>交货日期</label>
                            <div>{formatDate(item.expectedDate)}</div>
                          </li>
                        </ul>
                      </div>
                      <div className='progress-bar-box'>
                        <div className="u-progress-bar clearfix">
                          {item.deliveryQty > 0 && (
                            <span
                              className="level1"
                              style={{ width: item.deliveryRate + '%' }}
                            >
                              <span>已出货量：{item.deliveryQty}</span>
                            </span>
                          )}
                          {item.finishStockQty > 0 && (
                            <span
                              className="level2"
                              style={{ width: item.finishStockRate + '%' }}
                            >
                              <span>完工库存：{item.finishStockQty}</span>
                            </span>
                          )}
                          {item.unFinishStoreQty > 0 && (
                            <span
                              className="level3"
                              style={{
                                width: item.unTotalReportFinishRate + '%',
                              }}
                            >
                              <span>未完成量：{item.unFinishStoreQty}</span>
                            </span>
                          )}
                        </div>
                      </div>
                      {/* <ul className={'usually '}>
                        <li
                          className={
                            'u-sign ' +
                            ([2, 3].indexOf(item.poOrderStatus) > -1
                              ? 'red'
                              : [1, 4].indexOf(item.poOrderStatus) > -1
                              ? 'orange'
                              : item.poOrderStatus === 5
                              ? 'green'
                              : '')
                          }
                        >
                          {item.poOrderStatusName}
                        </li>
                      </ul> */}
                    </div>
                  ))}
                  {!this.state.showLoading && this.state.list.length === 0 && (
                    <LoadMore showLine> 暂无数据</LoadMore>
                  )}
                </div></div>
            </span>
          )}
        </Panel>
        <Toast icon="loading" show={this.state.showLoading}>
          数据加载中...
        </Toast>
        {
          // 附件查看
          Array.isArray(this.state.fileList) &&
          this.state.fileList.length > 0 && (
            <Download fileList={this.state.fileList} />
          )
        }
      </Page>
    );
  }
}

OrderReportList.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrderReportList));
